/**
 * Add query params to the url for vector to attribute the lead
 * @author DMV
 * @package DMV Adx Params
 * @description This script adds query parameters to the URL if they are not already present. It uses the URLSearchParams API to manipulate the query string.
 * @version 3.0.1
 */
$(document).ready(function () {
    // Check if the URL already has the parameters
    const urlParams = new URLSearchParams(window.location.search);
    // If the parameters are not present, add them
    let params = {
        'tg1': 'DVA',
        'utm_content': 'dmv.com',
        'utm_medium': 'dmv_',
        'tg7': 'dmv_',
        'utm_source': 'dmv.com',
        'tg9': 'dmv.com',
        'utm_term': 'organic_dmv',
        'utm_campaign': 'organic_dmv',
    }
    // Loop through the params object and add each key-value pair to the URL if it doesn't already exist
    Object.keys(params).forEach(key => {
        if (!urlParams.has(key)) {
            urlParams.append(key, params[key]);
        }
    });
    // Check if the URL already has the parameters
    window.history.pushState('', '', '?' + urlParams);
});


// WEBPACK FOOTER //
// ./scripts/plugins/dmv-params/index.js